<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1" v-if="auditright">待审核</el-menu-item>
        <el-menu-item index="2">已审核</el-menu-item>
        <el-menu-item index="4">门店汇总</el-menu-item>
        <el-menu-item index="3">跟踪日志</el-menu-item>
        <el-menu-item index="5">培训日志</el-menu-item>
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <comment :is="currentcomponent" :auditstatus="status" v-if="visible"></comment>
    </el-main>

  </div>

</template>

<script>
  import waitauditList from './waitauditList';
  import TrackingLog from './TrackingLog';
  import Externaldeptsub from './Externaldeptsub'

  export default {
    data() {
      return {
        auditright:false,
        viewright:false,
        activeIndex: '1',
        currentcomponent: '',
        visible: true,
        status: '1',
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.status = key
        this.visible = false
        if (key == 3) {
          this.currentcomponent = 'TrackingLog'
        } else if (key == 5) {
          this.currentcomponent = 'TrackingLog'
        } else if (key == 4) {
          this.currentcomponent = 'Externaldeptsub'
        } else {
          this.currentcomponent = 'waitauditList'
        }
        this.$nextTick(() => {
          this.visible = true
        })
      },
    },
    mounted() {
      this.auditright = this.$checkRight("审核门店")
      // this.viewright=this.$checkRight("查看门店")
      this.activeIndex = this.auditright ? '1' : '2';
      this.status= this.activeIndex;
      this.currentcomponent = waitauditList;// : "TrackingLog";
    },
    components: {
      waitauditList,
      TrackingLog,
      Externaldeptsub
    }

  }


</script>
<style scoped>
  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width: 100%;
    margin: 0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
    font-size: 13px;
    padding: 0 18px !important;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    background: linear-gradient(135deg, #f8f9fc 0%, #eef1f7 100%);
    border-radius: 6px 6px 0 0;
    padding: 0 4px;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    background: transparent;
    color: #409eff;
  }

  .el-menu--horizontal .el-menu-item.is-active {
    border-bottom: 3px solid #409eff !important;
    color: #222 !important;
    font-weight: 600;
    background: transparent !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/Waitaudit.vue